import React from 'react'
import PropTypes from 'prop-types'
import NextLink from 'next/link'
import cx from 'classnames'

export default function Link({
  children,
  to,
  variant = 'default',
  size = 'medium',
  className,
  external,
  openTab,
  ...props
}) {
  const externalProps = (external || openTab)
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {}

  return (
    <NextLink
      href={to}
      className={cx('nui-link', `nui-link--${size}`, `nui-link--${variant}`, className)}
      {...externalProps}
      {...props}
    >
      {children}
    </NextLink>
  )
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  external: PropTypes.bool,
  openTab: PropTypes.bool,
}
